const ShippingIcon = () => (
  <svg viewBox="0 0 60 62" width="15px">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="#000000" fillRule="nonzero">
        <path d="M59.5,16.6 L46.6,0.2 L13.4,0.2 L0.5,16.6 L0.5,61.8 L59.5,61.8 L59.5,16.6 L59.5,16.6 Z M54.4,15.5 L31.7,15.5 L31.7,3.6 L45,3.6 L54.4,15.5 Z M15,3.6 L28.3,3.6 L28.3,15.5 L5.6,15.5 L15,3.6 Z M3.8,58.4 L3.8,18.8 L56.2,18.8 L56.2,58.4 L3.8,58.4 Z M30,26.1 L38.7,34.8 L36.3,37.2 L31.6,32.5 L31.6,50.3 L28.3,50.3 L28.3,32.5 L23.6,37.2 L21.2,34.8 L30,26.1 Z"></path>
      </g>
    </g>
  </svg>
);
export default ShippingIcon;
